<template>
  <div class="d-block py-0 black--text w-80 row justify-content-center">
    <div class="col-12 col-md-6 d-flex justify-content-end mb-3">
      <v-checkbox
        v-model="showProduct"
        hide-details
        class="mt-0"
        label="Tampilkan Isi Paket"
      ></v-checkbox>
    </div>

    <div class="col-12 col-md-6">
      <table style="width: 500px; border: 2px solid black; border-collapse: collapse">
        <tbody>
          <tr>
            <td style="
                  border-top: 2px solid black;
                  border-left: 2px solid black;
                  border-bottom: 2px solid black;
                  padding: 0.5em;
                ">
              <!-- <img src="/assets/icons/logo-text-black.png" alt="logo-invoice" id="logo_invoice" style="height: 50px" /> -->
              <img :src="siteConfig.favicon" alt="logo-invoice" id="logo_invoice" style="height: 50px" />
            </td>
            <td style="
                  border-top: 2px solid black;
                  border-right: 2px solid black;
                  border-bottom: 2px solid black;
                  padding: 0.5em;
                  text-align: right;
                ">
              <span v-if="data && data.trx_shipping_method == 'courier'">
                <img :src="'/assets/courier/' + data.trx_courier_code + '.svg'" alt="logo-kurir" id="logo_invoice"
                  style="height: 40px" />
              </span>
            </td>
          </tr>
          <tr v-if="data.awb_kiriminaja">
            <td style="
                  border: 2px solid black;
                  padding: 0.5em;
                  vertical-align: top;
                  text-align: center;
                " colspan="2">
              <!-- <strong>NON-COD</strong> -->
              <barcode id="awb" style="display: block; width: 100%; height: 100px;" tag="img"
                :options="{ displayValue: false }" :value="data.awb_kiriminaja"></barcode>
              <strong>AWB: {{ data.awb_kiriminaja }}</strong>
            </td>
          </tr>
          <tr v-else>
            <td style="
                  border: 2px solid black;
                  padding: 0.5em;
                  vertical-align: top;
                  text-align: left;
                " colspan="2">
              <strong>
                NOMOR AWB:
              </strong>
              <!-- <strong style="color:red">
                SISTEM SEDANG MENUNGGU CALLBACK NOMOR RESI, MOHON UNTUK TIDAK DICETAK
                HINGGA MENDAPATKAN NOMOR RESI. 
              </strong> -->
            </td>
          </tr>
          <tr>
            <td style="
                  border: 2px solid black;
                  padding: 0.5em;
                  vertical-align: top;
                  text-align: center;
                " colspan="2">
              <!-- <strong>NON-COD</strong> -->
              <strong v-if="data.is_cod == '1'">COD: {{ data.trx_price_shipping | toRupiah }}</strong>
              <strong v-else>NON-COD</strong>
            </td>
          </tr>
          <tr>
            <td style="
                  border: 2px solid black;
                  padding: 0.5em;
                  vertical-align: top;
                  text-align: center;
                " colspan="2">
              <strong>
                <span>
                  <div>
                    <div>
                      JENIS LAYANAN:
                      {{
                data.trx_courier_code
                  ? data.trx_courier_code.toUpperCase()
                  : ""
              }}
                      - {{ data.trx_courier_service }}
                    </div>
                  </div>
                </span>
              </strong>
            </td>
          </tr>
          <template v-if="data.trx_agregator == 'kiriminaja'">
            <tr>
              <td style="
                  border: 2px solid black;
                  padding: 0.5em;
                  vertical-align: top;
                  width: 60%;
                " rowspan="3">
                <center v-if="data.order_id_kiriminaja">
                  <barcode id="awb" style="display: block; width: 100%; height: 100%" tag="img"
                    :options="{ displayValue: false }" :value="data.order_id_kiriminaja"></barcode>
                  <strong style="font-size: 10px">OID : {{ data.order_id_kiriminaja }}</strong>
                </center>

              </td>
              <td style="border: 2px solid black; padding: 0.5em; vertical-align: top">
                <strong>Asuransi: {{ data.trx_price_insurance | toRupiah }}</strong>
              </td>
            </tr>
            <tr>
              <td style="border: 2px solid black; padding: 0.5em; vertical-align: top">
                <strong>
                  <span>
                    <div>
                      <div>Berat: {{ grandWeightTotal | toKg }}</div>
                    </div>
                  </span>
                </strong>
              </td>
            </tr>
            <tr>
              <td style="border: 2px solid black; padding: 0.5em; vertical-align: top">
                <strong>
                  <span>
                    <div>
                      <div>Quantity: {{ qty }}</div>
                    </div>
                  </span>
                </strong>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td style="border: 2px solid black; padding: 0.5em; vertical-align: top">
                <strong>
                  <span>
                    <div>
                      <div>Berat: {{ grandWeightTotal | toKg }}</div>
                    </div>
                  </span>
                </strong>
              </td>
              <td style="border: 2px solid black; padding: 0.5em; vertical-align: top">
                <strong>
                  <span>
                    <div>
                      <div>Quantity: {{ qty }}</div>
                    </div>
                  </span>
                </strong>
              </td>
            </tr>
          </template>
          <tr v-if="showProduct">
            <td style="border: 2px solid black; padding: 0.5em; vertical-align: top" colspan="2">
              <strong>
                Isi Paket :
                <br />
                <strong>{{ isiPaket }}</strong>
              </strong>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 0.5em; vertical-align: top">
              <strong>
                Penerima :
                <br />
                <span>
                  <div class="text-caption pr-5">
                    <strong>{{ data.destination_name }}</strong>
                    <br />
                    {{ data.destination_phone }} | {{ data.destination_address }},
                    {{ data.user_address_subdistrict_name }},
                    {{ data.user_address_city_name }},
                    {{ data.user_address_province_name }},
                    {{ data.user_address_zipcode }}
                    <br />
                  </div>
                  <!-- <pre>{{rows.shipping_json.param.packages}}</pre> -->
                </span>
              </strong>
            </td>
            <td style="border: 2px solid black; padding: 0.5em; vertical-align: top">
              <strong>
                Pengirim :
                <br />
                {{ data.trx_store_name }},
                <br />
                {{ data.origin_phone }}
              </strong>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 0.5em; vertical-align: top" colspan="2">
              <strong>CATATAN: {{ data.trx_courier_note }}</strong>
            </td>
          </tr>
          <tr>
            <td style="border: 2px solid black; padding: 0.5em; vertical-align: top" colspan="2">
              <strong>
                PASTIKAN REKAM VIDEO KETIKA UNBOXING. KLAIM KERUSAKAN AKIBAT
                PENGIRIMAN TANPA VIDEO, TIDAK DAPAT DITINDAK LANJUTI
              </strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <v-card elevation="0" outlined flat shaped tile class="card-darker mb-5">
      <v-card-title class="py-2">
        <div class="text-subtitle-1 font-weight-bold">Ringkasan Pembayaran</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-5">
        <div class="text-subtitle-2">Total Belanja</div>
        <div
          class="d-flex"
          :class="
            isMobile
              ? 'flex-column justify-start'
              : 'flex-row align-center justify-space-between'
          "
        >
          <span class="font-weight-bold"
            >- {{ data.trx_store_name }} ({{ data.trx_code }})</span
          >
          <span
            :class="
              isMobile
                ? 'd-block text-subtitle-1 text-left mt-2 font-weight-bold black--text'
                : 'text-right'
            "
            >{{ data.trx_bill }}</span
          >
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="py-0">
        <v-row justify="space-between" class="px-2">
          <v-col cols="12" sm="6" :class="{ 'pb-1 text-right': isMobile }">
            <span class="d-block text-subtitle-2 font-weight-bold"
              >Subtotal Belanja</span
            >
          </v-col>
          <v-col cols="12" sm="6" :class="{ 'pt-0 text-right': isMobile }">
            <span
              class="d-block font-weight-bold"
              :class="
                isMobile ? 'text-subtitle-1' : 'text-subtitle-2 text-right'
              "
              >{{ data.trx_bill }}</span
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>-->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    data: Object,
    isMobile: Boolean,
    grandWeightTotal: Number
  },
  data() {
    return {
      showProduct: true
    }
  },
  computed: {
    ...mapState("kiriminaja", [
      "siteConfig",
    ]),
    // ...mapState("storeSeller", ["detailStore"]),
    isiPaket() {
      if (!this.data) return "";
      else {
        let dataItem = this.data.trx_detail;
        let strIsi = "";
        dataItem.forEach((row, idx) => {
          if (idx == 0) {
            strIsi += row.trx_detail_product_name;
          } else {
            strIsi += "," + row.trx_detail_product_name;
          }
        });
        if (strIsi != "") {
          strIsi = strIsi.substr(0, 50);
        }
        return strIsi;
      }
    },
    products() {
      if (!this.data) return [];
      return this.data.trx_detail;
    },
    qty() {
      if (this.products.length < 1) return 0;
      return this.products.reduce(
        (a, b) => a + Number(b.trx_detail_quantity),
        0
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>